export const unitExceptions = [
  'digital',
  'streaming',
  'positioning',
  'enum',
  'color',
];

export const buildUnitOptions = (units, t, typeList, unitList) =>
  units
    ?.filter(m => !typeList || typeList.includes(m.label))
    .map(m => ({
      type: {
        value: m.label,
        label: t(`measures.types.${m.label}`),
      },
      units: Object.keys(m.value)
        .filter(k => !unitList || unitList.some(ul => m.value[k].includes(ul)))
        .map(k => ({
          category: {
            value: k,
            label: t(`measures.categories.${k}`),
          },
          list: m.value[k]
            .filter(l => !unitList || unitList.includes(l))
            .map(l => {
              const unitTranslation = t(`measures.units.${l}`);
              return {
                value: l,
                label:
                  k !== 'counter'
                    ? `${l} - ${unitTranslation}`
                    : unitTranslation,
              };
            }),
        })),
    }));

export const buildUnitLabels = (units, t) => {
  const labels = {};
  units?.forEach(m => {
    Object.keys(m.value).forEach(k => {
      m.value[k].forEach(u => {
        const unitTranslation = t(`measures.units.${u}`);
        labels[u] =
          k !== 'counter' ? `${u} - ${unitTranslation}` : unitTranslation;
      });
    });
  });
  labels.digital = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.digital',
  );
  labels.streaming = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.streaming',
  );
  labels.positioning = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.positioning',
  );
  labels.enum = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.enum',
  );
  labels.color = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.color',
  );
  return labels;
};

export const buildUnitTypeLabels = (units, t) => {
  const labels = {};
  units?.forEach(m => {
    labels[m.label] = t(`measures.types.${m.label}`);
  });
  labels.digital = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.digital',
  );
  labels.streaming = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.streaming',
  );
  labels.positioning = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.positioning',
  );
  labels.enum = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.enum',
  );
  labels.color = t(
    'management_menu.asset_wizard.sensor_type.measuring_mode_options.color',
  );
  return labels;
};
